export default "__VITE_ASSET__$4Cdmay4__"